import { render, staticRenderFns } from "./ModalConfirmPassword.vue?vue&type=template&id=3ad6c7c0&lang=pug&"
import script from "./ModalConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmPassword.vue?vue&type=style&index=0&id=3ad6c7c0&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports